module.exports = __webpack_public_path__ + "img/de-product-classify_img_1.4b69a80d.jpg";